import React from "react";
import { Link } from "react-router-dom";
import { Layers, Grid3x3, Settings2, FileCheck2, ArrowRight } from "lucide-react";
import { evaluationSteps } from "../data/mock";

const icons = [Layers, Grid3x3, Settings2, FileCheck2];

const EvaluationFramework = () => {
  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid lg:grid-cols-[1fr_380px] gap-5">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <h3 className="font-bold text-[#111827] text-lg mb-1">Evidence publication framework</h3>
          <p className="text-sm text-slate-500 mb-6">55 criteria per platform, each with a source status, date and withheld-score reason.</p>
          <div className="flex items-center justify-between">
            {evaluationSteps.map((step, i) => {
              const Icon = icons[i];
              return (
                <React.Fragment key={step.subLabel}>
                  <div className="flex flex-col items-center text-center">
                    <div className="w-14 h-14 rounded-xl bg-indigo-50 flex items-center justify-center mb-2">
                      <Icon className="w-6 h-6 text-indigo-600" />
                    </div>
                    <p className="font-bold text-[#111827] text-sm">{step.label}</p>
                    <p className="text-xs text-slate-500">{step.subLabel}</p>
                  </div>
                  {i < evaluationSteps.length - 1 && <ArrowRight className="w-5 h-5 text-slate-300 shrink-0" />}
                </React.Fragment>
              );
            })}
          </div>
          <Link to="/methodology" className="inline-flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:text-indigo-700 mt-6">
            Learn about our methodology <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="bg-[#EEF2FF] rounded-2xl border border-indigo-100 p-6">
          <h3 className="font-bold text-[#111827] text-lg mb-3">Fit rating versus product quality</h3>
          <p className="text-sm text-slate-600 leading-relaxed">
            The fit rating measures documented alignment with a disclosed all-in-one commerce-and-operations profile.
            Official documentation cannot, by itself, establish quality, reliability or universal superiority, so
            product-quality scores remain withheld.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EvaluationFramework;
